<ng-container *ngIf="isIllistration">
    <img [src]="src" [ngStyle]="style" class="fc-illistration" [alt]="altText" loading="lazy">
</ng-container>
<ng-container *ngIf="!isIllistration">
    <i [ngClass]="src" [ngStyle]="style" style="vertical-align: inherit;"></i>
</ng-container>